import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () =>
      import('./home/home.module').then((m) => m.HomePageModule),
  },
  /* {
    path: 'home/serviceCancel/:id',
    loadChildren: () =>
      import('./home/home.module').then((m) => m.HomePageModule),
  }, */
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'login/:id',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'register',
    loadChildren: () =>
      import('./register/register.module').then((m) => m.RegisterPageModule),
  },
  {
    path: 'services',
    loadChildren: () =>
      import('./services/services.module').then((m) => m.ServicesPageModule),
  },
  {
    path: 'services/:id',
    loadChildren: () =>
      import('./services/services.module').then((m) => m.ServicesPageModule),
  },
  {
    path: 'services/update/:id',
    loadChildren: () =>
      import('./services/services.module').then((m) => m.ServicesPageModule),
  },
  {
    path: 'services/pick',
    loadChildren: () =>
      import('./services/services.module').then((m) => m.ServicesPageModule),
  },
  {
    path: 'service-thing',
    loadChildren: () =>
      import('./service-thing/service-thing.module').then(
        (m) => m.ServiceThingPageModule,
      ),
  },
  {
    path: 'forgotPassword',
    loadChildren: () =>
      import('./forgot-password/forgot-password.module').then(
        (m) => m.ForgotPasswordPageModule,
      ),
  },
  {
    path: 'myProfile',
    loadChildren: () =>
      import('./my-profile/my-profile.module').then(
        (m) => m.MyProfilePageModule,
      ),
  },
  {
    path: 'payment/add',
    loadChildren: () =>
      import('./add-payment/add-payment.module').then(
        (m) => m.AddPaymentPageModule,
      ),
  },
  {
    path: 'payment/edit/:id',
    loadChildren: () =>
      import('./add-payment/add-payment.module').then(
        (m) => m.AddPaymentPageModule,
      ),
  },
  {
    path: 'myPayments',
    loadChildren: () =>
      import('./my-payments/my-payments.module').then(
        (m) => m.MyPaymentsPageModule,
      ),
  },
  {
    path: 'changePassword',
    loadChildren: () =>
      import('./change-password/change-password.module').then(
        (m) => m.ChangePasswordPageModule,
      ),
  },
  {
    path: 'servicesHistory',
    loadChildren: () =>
      import(
        './all-service-history/services-history/services-history.module'
      ).then((m) => m.ServicesHistoryPageModule),
  },
  {
    path: 'serviceDetails/:id',
    loadChildren: () => import('./all-service-history/service-details/service-details.module').then( m => m.ServiceDetailsPageModule)
  },
  {
    path: 'courierFees',
    loadChildren: () =>
      import('./fee-calculations/courier-fees/courier-fees.module').then(
        (m) => m.CourierFeesPageModule,
      ),
  },
  {
    path: 'lostFound',
    loadChildren: () =>
      import('./reports/lost-found/lost-found.module').then(
        (m) => m.LostFoundPageModule,
      ),
  },
  {
    path: 'safety',
    loadChildren: () =>
      import('./reports/safety/safety.module').then((m) => m.SafetyPageModule),
  },
  {
    path: 'contactUs',
    loadChildren: () =>
      import('./reports/contact-us/contact-us.module').then(
        (m) => m.ContactUsPageModule,
      ),
  },
  {
    path: 'ongoingService',
    loadChildren: () =>
      import('./ongoing-service/ongoing-service.module').then(
        (m) => m.OngoingServicePageModule,
      ),
  },
  {
    path: 'externalPayment',
    loadChildren: () =>
      import('./external-payment/external-payment.module').then(
        (m) => m.ExternalPaymentPageModule,
      ),
  },
  {
    path: 'forgot-modal',
    loadChildren: () =>
      import('./modals/forgot-modal/forgot-modal.module').then(
        (m) => m.ForgotModalPageModule,
      ),
  },
  {
    path: 'login-modal',
    loadChildren: () =>
      import('./modals/login-modal/login-modal.module').then(
        (m) => m.LoginModalPageModule,
      ),
  },
  {
    path: 'verify-code-modal',
    loadChildren: () =>
      import('./modals/verify-code-modal/verify-code-modal.module').then(
        (m) => m.VerifyCodeModalPageModule,
      ),
  },
  {
    path: 'email-exists-modal',
    loadChildren: () =>
      import('./modals/email-exists-modal/email-exists-modal.module').then(
        (m) => m.EmailExistsModalPageModule,
      ),
  },
  {
    path: 'serviceFlow/:id',
    loadChildren: () =>
      import('./all-service-history/service-flow/service-flow.module').then(
        (m) => m.ServiceFlowPageModule,
      ),
  },
  {
    path: 'checkStatus',
    loadChildren: () =>
      import('./check-status/check-status.module').then(
        (m) => m.CheckStatusPageModule,
      ),
  },
  {
    path: 'header',
    loadChildren: () => import('./header/header.module').then( m => m.HeaderPageModule)
  },
  {
    path: 'footer',
    loadChildren: () => import('./footer/footer.module').then( m => m.FooterPageModule)
  },
  {
    path: 'savedOrders',
    loadChildren: () => import('./save-orders/save-orders.module').then( m => m.SaveOrdersPageModule)
  },
  {
    path: 'chat-bubble',
    loadChildren: () => import('./chat-bubble/chat-bubble.module').then( m => m.ChatBubblePageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
